import { render } from "./CreateQuotationPage.vue?vue&type=template&id=76f539c1&ts=true"
import script from "./CreateQuotationPage.vue?vue&type=script&lang=ts"
export * from "./CreateQuotationPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__